// For full API-dokumentasjon, inkludert kodeeksempler, besøk https://wix.to/94BuAAs

$w.onReady(function () {
$w.onReady(function () {
    makeResponsive("#text2","h4",5);
});
 
// Responsive Text Function - Do Not Edit
function makeResponsive(elementId,textTheme,fontSize,fontColor,lineHeight,charSpacing,width) {
let style = "font-size:"+fontSize+"vw;color:"+fontColor+";line-height:"+lineHeight+";letter-spacing:"+charSpacing+"vw;width:"+width+"vw";
$w(elementId).html = "<"+textTheme+" style="+style+">"+$w(elementId).text+"</"+textTheme+">";
}
});